// @gs/feedback/client — point d'entree React (SPA). Le serveur vit sous
// '@gs/feedback/server'. i18n : namespace `feedback` — l'app fusionne
// `feedbackResources` dans son initI18n (pattern namespace par app @gs/i18n).
import feedbackFr from './locales/feedback.fr.json';
import feedbackEn from './locales/feedback.en.json';

export { FeedbackLauncher, type FeedbackLauncherProps } from './FeedbackLauncher';
export { FeedbackModal, type FeedbackModalProps } from './FeedbackModal';
export { PublishAnnouncementModal, type PublishAnnouncementModalProps } from './PublishAnnouncementModal';
export { TicketList, type TicketListProps } from './TicketList';
export { TicketThread, type TicketThreadProps } from './TicketThread';
export { FeedbackPage, type FeedbackPageProps } from './FeedbackPage';
export {
  useFeedbackTickets,
  useFeedbackUnreadCount,
  useTicketDetail,
  useTicketMessages,
  useTicketNotes,
  useTicketActivity,
  useTicketAttachments,
  useCreateTicket,
  usePublishAnnouncement,
  useSendMessage,
  useEditMessage,
  useDeleteMessage,
  useToggleReaction,
  useTriage,
  useSetTicketStatus,
  useFollow,
  useAddNote,
  useMarkRead,
  uploadAttachment,
  isFeedbackMigrationPending,
  isFeedbackUnavailable,
  FEEDBACK_REFETCH_MS,
} from './hooks';

/** Ressources i18n du namespace `feedback` — a fusionner dans initI18n de l'app. */
export const feedbackResources = {
  fr: { feedback: feedbackFr },
  en: { feedback: feedbackEn },
} as const;
